export function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * `react-snap` sets `window.__REACT_SNAP__ = true` while prerendering.
 * We use this to avoid firing networked side effects during the snapshot phase.
 */
export function isReactSnap(): boolean {
  return isBrowser() && Boolean((window as any).__REACT_SNAP__);
}
